var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "viq54yyp7a",
    d: "M15.625 1.042h-6.25v2.083h6.25V1.042zm-4.167 13.541h2.084v-6.25h-2.084v6.25zm8.365-6.885l1.48-1.48c-.449-.53-.938-1.03-1.47-1.468l-1.479 1.48C16.74 4.936 14.708 4.166 12.5 4.166c-5.177 0-9.375 4.198-9.375 9.375s4.188 9.375 9.375 9.375c5.188 0 9.375-4.198 9.375-9.375 0-2.209-.77-4.24-2.052-5.844zM12.5 20.833c-4.031 0-7.292-3.26-7.292-7.291 0-4.032 3.26-7.292 7.292-7.292 4.031 0 7.292 3.26 7.292 7.292 0 4.03-3.26 7.291-7.292 7.291z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -25) translate(79 25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2ib0663q0b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#viq54yyp7a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#2ib0663q0b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H52.083V52.083H0z",
    transform: "translate(-13.542 -13.542)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimer);
export default __webpack_public_path__ + "static/media/ic-timer.3b0896d8b4dcaba9e3069b3f70170ac1.svg";
export { ForwardRef as ReactComponent };